export default __webpack_public_path__ + "static/media/user.90eae6bc.png";